module.exports = __webpack_public_path__ + "static/img/office.c427c71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/office.png
// module id = iKVB
// module chunks = 0